import React from 'react';
import Button from '../UI/Button';
import PulsingGlow from '../UI/PulsingGlow';
import './HeroSection.css';

const HeroSection: React.FC = () => {
  return (
    <section className="hero section">
      <div className="container">
        <div className="hero-content">
          <h1 className="hero-title">
            Планировка квартир<br />на новом уровне
          </h1>
          <p className="hero-description">
            Революционное AI решение для архитекторов, позволяющее сэкономить месяцы работы 
            при проектировании и планировании квартир в многоэтажных зданиях.
          </p>
        </div>
        
        <div className="hero-image">
          <img src="/kvadro_floorplan_2_min.png" alt="Планировка этажа KVADRO" />
          
          {/* Add pulsing glow effect under the image */}
          <PulsingGlow 
            height="80px" 
            color="rgba(255, 255, 255, 0.15)"
            duration={5}
            className="hero-glow"
          />
        </div>
        
        <div className="hero-cta">
          <Button href="#contact" variant="gradient" size="large">
            Получить консультацию
          </Button>
        </div>
      </div>
      
    </section>
  );
};

export default HeroSection;